import { TypographyParagraph, TypographyLabel } from '../../typography'
import TypographyHeader from '../../typography/TypographyHeading'
import { ImageIcon, OnChainIcon } from '../../icons'

type CollectionProps = {
  metadata: {
    properties: {
      name?: string;
      description?: string;
      artistName?: string;
      nftCount?: number;
      chains?: string[];
    };
  };
}

export default function Collection({ metadata }: CollectionProps) {
  const { properties } = metadata;

  return (
    <div className="flex flex-col space-y-2">
      {/* Collection Title */}
      <div className="flex items-center space-x-2 text-textPrimaryLight dark:text-textPrimaryDark">
        <TypographyHeader size="small">
          {properties.name || 'Untitled Collection'}
        </TypographyHeader>
      </div>

      {/*TODO: Artist Name ? The collection could be made by non artists */}
      {properties.artistName && (
        <TypographyLabel size="small" additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark">
          by {properties.artistName}
        </TypographyLabel>
      )}

      {/* Collection artwork Count */}
      {properties.nftCount && (
        <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
          <ImageIcon size="small" />
          <TypographyLabel size="small">
            {properties.nftCount} {properties.nftCount === 1 ? 'artwork' : 'artworks'}
          </TypographyLabel>
        </div>
      )}

			{/* Collection chains */}
      {properties.chains && (
        <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
          <OnChainIcon size="small" />
          <TypographyLabel size="small">
						{properties.chains.map(chain => chain.charAt(0).toUpperCase() + chain.slice(1)).join(', ')}
          </TypographyLabel>
        </div>
      )}

      {/* Collection Description */}
      <TypographyParagraph size="small" additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark">
        {properties.description || 'No description available'}
      </TypographyParagraph>

    </div>
  );
} 